import { useEffect, useState } from "react";
import Icon from "../Icon/Icon";
import { BookmarkProps } from "./Bookmark.model";
import styles from "./Bookmark.module.scss";

const Bookmark = ({ isBookmarked, onBookmark, onDeleteBookmark }: BookmarkProps) => {
  const [ bookmarkState, setBookmarkState ] = useState<boolean>(isBookmarked);

  useEffect(() => {
    setBookmarkState(isBookmarked);
  }, [ isBookmarked ]);

  const onClickBookmark = () => {
    if (bookmarkState) onDeleteBookmark();
    else onBookmark();
    
    setBookmarkState(!bookmarkState);
  }

  return (
    <div className={styles.bookmarkWrapper} onClick={onClickBookmark}>
      	<Icon
          className={styles.bookmarkBg}
          name="bookmark"
          height="22px"
          type="solid"
          width="22px" />
				<Icon
          name="bookmark"
          color={bookmarkState ? "accent" : "light"}
          height="16px"
          type={bookmarkState ? "solid" : "light"}
          width="16px" />
			</div>
  )
}

export default Bookmark;